<template>
  <Footer>
    <p>copyright © 2018 磐石保險經紀人股份有限公司</p>
  </Footer>
</template>

<script>
  export default {
    
  };
</script>
